// # Protected Route Component for Users - Subscription Based Access
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../auth/state';
import Loading from '../../components/common/Loading';
import sessionManager from '../../auth/session';

const ProtectedRouteUser = ({ children, requiredSubscription }) => {
  const { isAuthenticated, loading, user, isAdmin, isTutor } = useAuthStore();
  const location = useLocation();

  // # Show loading state
  if (loading) {
    return <Loading message="Loading..." />;
  }

  // # Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }

  // # If admin or tutor, allow access to mentorship features
  if ((isAdmin || isTutor) && location.pathname.includes('mentorship')) {
    return children;
  }

  // # If no subscription is required, render children
  if (!requiredSubscription) {
    console.log('[ProtectedRouteUser] No subscription required, rendering children');
    return children;
  }

  // # Check access based on subscription rules
  let hasAccess = false;
  
  // # Direct subscription check
  const directAccess = sessionManager.isSubscribed(requiredSubscription);
  
  // # Apply access rules based on subscription type
  if (directAccess) {
    hasAccess = true;
  } else if (requiredSubscription === 'step1_library') {
    // Step 1 mentorship grants access to Step 1 library
    hasAccess = sessionManager.isSubscribed('step1_mentorship');
  } else if (requiredSubscription === 'step2_library') {
    // Step 2 mentorship grants access to Step 2 library
    hasAccess = sessionManager.isSubscribed('step2_mentorship');
  } else if (requiredSubscription === 'step1_mentorship') {
    // Only step1_mentorship subscription can access step1_mentorship
    hasAccess = sessionManager.isSubscribed('step1_mentorship');
  } else if (requiredSubscription === 'step2_mentorship') {
    // Only step2_mentorship subscription can access step2_mentorship
    hasAccess = sessionManager.isSubscribed('step2_mentorship');
  }
  
  // # If user doesn't have access, redirect to products page
  if (!hasAccess) {
    console.log(`[ProtectedRouteUser] User doesn't have required subscription: ${requiredSubscription}, redirecting to products`);
    return <Navigate to="/products" replace />;
  }

  // # User is authenticated and has required subscription, render children
  console.log(`[ProtectedRouteUser] User has required subscription: ${requiredSubscription}, rendering children`);
  return children;
};

export default ProtectedRouteUser;
